import React, { useEffect, useRef, useState } from "react";
import CalendarSidebarticketGroup from "./CalendarSidebarTicketGroup";

const CalendarSideBar = ({ isOpen, onClose, selectedDate }) => {
  const [openTickets, setOpenTickets] = useState([]);
  const [closedTickets, setClosedTickets] = useState([]);
  const [scheduledTickets, setScheduledTickets] = useState([]);
  const sidebarRef = useRef(null);

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  useEffect(() => {
    if (!selectedDate?.tickets) {
      setOpenTickets([]);
      setClosedTickets([]);
      setScheduledTickets([]);
      return;
    }

    const today = new Date();
    const open = [];
    const closed = [];
    const scheduled = [];

    selectedDate.tickets.forEach((ticket) => {
      const startDate = new Date(ticket.startDate);

      if (ticket.status === 100) {
        closed.push(ticket);
      } else if (startDate < today) {
        open.push(ticket);
      } else if (startDate > today) {
        scheduled.push(ticket);
      }
    });

    setOpenTickets(open);
    setClosedTickets(closed);
    setScheduledTickets(scheduled);
  }, [selectedDate]);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-20 transition-opacity" />
      )}
      <div
        ref={sidebarRef}
        className={`flex justify-between fixed top-0 right-0 bottom-0 w-[493px] transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-start bg-transparent px-2 py-4">
          <button
            onClick={onClose}
            className="text-black bg-white w-8 h-8 rounded-full flex items-center justify-center"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="flex flex-col w-[425.45px] h-full bg-white shadow-[0_4px_4px_rgba(0,0,0,0.25)]">
          <div className="pt-[14.33px] pl-[32.45px] pb-[16.67px]">
            <div className="flex justify-between items-center">
              <h2 className="text-2xl">
                {selectedDate
                  ? `${new Date(
                      selectedDate.year,
                      selectedDate.month
                    ).toLocaleString("default", { month: "long" })} ${
                      selectedDate.day
                    }${getDaySuffix(selectedDate.day)}, ${selectedDate.year}`
                  : "Calendar Details"}
              </h2>
            </div>
          </div>
          <div className="flex flex-col space-y-3 overflow-y-auto">
            {openTickets.length > 0 && (
              <CalendarSidebarticketGroup tickets={openTickets} status="Open" />
            )}
            {closedTickets.length > 0 && (
              <CalendarSidebarticketGroup
                tickets={closedTickets}
                status="Closed"
              />
            )}
            {scheduledTickets.length > 0 && (
              <CalendarSidebarticketGroup
                tickets={scheduledTickets}
                status="Scheduled"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CalendarSideBar;
